import API from '../endpoints';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import axios from 'axios';

export type LeagueTableQueryArgs = {
  externalTeamId?: string;
  leagueId?: string;
};

type QueryOptions = {
  enabled: boolean;
};

export const useLeagueTableQuery = (args: LeagueTableQueryArgs, options?: QueryOptions) => {
  return useQuery({ queryKey: ['league-table', args], queryFn: fetchLeagueTable, ...(options ?? {}) });
};

const fetchLeagueTable: QueryFunction<any, [string, LeagueTableQueryArgs]> = async ({ queryKey }) => {
  const [, params] = queryKey;

  const { data } = await axios.get<any>(API.endpoints.leagueTable, {
    params,
  });
  return data;
};
